/**
 * Shim für expo/dom/global (fehlt in Expo SDK 49 bei Webpack-Web-Build).
 * expo-router nutzt addGlobalDomEventListener; auf Web reicht ein No-Op.
 * CommonJS, damit Babel-Loader keine Probleme macht.
 */
"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.addGlobalDomEventListener = void 0;
function addGlobalDomEventListener(_handler) {
  return function () {};
}
exports.addGlobalDomEventListener = addGlobalDomEventListener;
